import { render, staticRenderFns } from "./filters.vue?vue&type=template&id=2ef0bbb3&"
import script from "./filters.vue?vue&type=script&lang=js&"
export * from "./filters.vue?vue&type=script&lang=js&"
import style0 from "./filters.vue?vue&type=style&index=0&id=2ef0bbb3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports